module.exports = __webpack_public_path__ + "img/emerald-mine.e13350c3.png";